// extracted by mini-css-extract-plugin
export var aircallIframe = "_md-3";
export var fabContainer = "_md-5";
export var fabRinging = "_md-6";
export var loadingOverlay = "_md-4";
export var pulse = "_md-7";
export var widgetContent = "_md-2";
export var widgetPanel = "_md-0";
export var widgetPanelExpanded = "_md-1";